import { ToolbarService } from './appToolBarService';
import { LogoutDialogService } from './logoutDialogService/logoutDialogService';
import { DeferredPermissionMenuItemFactory } from 'sharebase-app/factories/deferredpermissionMenuItemFactory'
import { ShareDialogServiceFactory } from './shareDialogService';
import { DocumentNavigationService } from './documentNavigationService';
import { FullTextUIService } from './fullTextService';
import { DetailsPanelService } from './detailsPanelService';

export const servicesModule = angular
	.module('sharebase-app.services', [
		'sharebase'
	])
	.service('sbaToolbarService', ToolbarService)
	.factory('sbaShareDialogService', ShareDialogServiceFactory)
	.service('sbaDetailsPanelService', DetailsPanelService)
	.service('sbaDocumentNavigationService', DocumentNavigationService)
	.service('sbaLogoutDialogService', LogoutDialogService)
	.service('sbaDeferredPermissionMenuItemFactory', DeferredPermissionMenuItemFactory)
	.service('sbaFullTextUIService', DeferredPermissionMenuItemFactory);


// WEBPACK FOOTER //
// ./src/sharebase-app/services/index.ts